import { render, staticRenderFns } from "./findPass.vue?vue&type=template&id=5f52e194&"
import script from "./findPass.vue?vue&type=script&lang=js&"
export * from "./findPass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports